export default "__VITE_ASSET__K5lH8r8T__"